// extracted by mini-css-extract-plugin
module.exports = {"page":"river-3-series-portable-power-station_page__TEwpo"};